import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    user: JSON.parse(sessionStorage.getItem('userData')) || null,
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload;
            sessionStorage.setItem('userData', JSON.stringify(action.payload));
        },
        updateUser: (state, action) => {
            state.user = { ...state.user, ...action.payload };
            sessionStorage.setItem('userData', JSON.stringify(state.user));
        },
        clearUser: (state) => {
            state.user = null;
            sessionStorage.removeItem('userData');
        },
    },
});

export const { setUser, updateUser, clearUser } = userSlice.actions;
export default userSlice.reducer;
